import { ChangeDetectionStrategy, Component, computed, input, Input, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { ImageLoadingComponent } from '@common/image-loading/image-loading.component';

@Component({
  selector: 'app-empty-placeholder',
  templateUrl: './empty-placeholder.component.html',
  styleUrls: ['./empty-placeholder.component.scss'],
  imports: [ImageLoadingComponent, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyPlaceholderComponent {
  readonly textMarginTop = computed(() => {
    if (!this.textMargin()) {
      return this.isMobile ? 27 : 10;
    }
    return this.textMargin();
  });

  @Input({ required: true }) src!: string;
  @Input({ required: true }) message!: string;
  @Input() minHeight = 345;
  @Input() imgSize = 75;
  @Input() isMobile = false;
  @Input() paddingTop = 0;
  @Input() template?: TemplateRef<any>;
  @Input() fontColor = 'var(--text-light-gray)';

  textMargin = input<number>();
}
